// CLARTEXT · Abschlussseite 2.0 · UI-V1
// Kopfleiste, Erfolgsbereich (Check-Ring + Titel + Untertitel), Werkchips,
// Werk-Eigentumssatz. 1:1-Übernahme aus abschluss-prototyp-v2.html.
// Header-Zeile mit CLARTEXT-Markenzeichen + Kopfnotiz.
export function AbschlussHeader() {
  return (
    <header
      className="hdr"
      data-testid="abschluss-v2-header"
      role="banner"
    >
      <div className="wrap hdr-in">
        <span className="brand" aria-label="CLartext">
          <span className="mk" aria-hidden="true">
            C
          </span>
          <span className="wm">CLartext</span>
        </span>
        <span className="hdr-note">Ihre Arbeitsschutz-Dokumentation</span>
      </div>
    </header>
  );
}

// Erfolgsbereich mit animiertem Check-Ring, Erfolgstitel, Untertitel,
// 6 Werkchips und Eigentumssatz.
export default function AbschlussHero() {
  return (
    <section
      className="top"
      data-testid="abschluss-v2-hero"
      aria-labelledby="abschluss-v2-success-title"
    >
      <div className="wrap">
        <div className="check-ring reveal in" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <path className="ck" d="M4.5 12.5l5 5L19.5 7" />
          </svg>
        </div>
        <h1
          id="abschluss-v2-success-title"
          className="reveal in"
          data-testid="abschluss-v2-success-title"
        >
          Geschafft. Ihre Arbeitsschutz-Dokumentation ist fertig.
        </h1>
        <p className="sub reveal in d1">
          Es ist Ihr Werk, keine Vorlage — prüfen Sie es in Ruhe. Und wie es
          damit weitergeht, entscheiden allein Sie.
        </p>
      </div>
    </section>
  );
}
